import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/auth';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import config from './config.js';
import './App.css';
import theme from './theme.js';

import Auth from './pages/Auth';
import Home from './pages/Home';
import Logout from './pages/Logout';
import NotFound from './pages/NotFound';
import Review from './pages/Review';

firebase.initializeApp(config);
firebase.functions();

class App extends Component {
  constructor (props) {
    super(props);

    this.state = {
      user: undefined,
    }
  }

  componentDidMount () {
    firebase.auth().onAuthStateChanged(user =>
      // We set this to user either way. If it's null, this sets user to null and signs them out.
      this.setState({ user }));
  }

  render () {
    return (
      <ThemeProvider theme={theme}>
        <Router>
          <div className="App">
            <Switch>
              <Route exact={true} path="/" render={props => <Home {...props} user={this.state.user} />} />
              <Route path="/review" component={Review} />
              <Route path="/login" render={(props) => <Auth {...props} user={this.state.user} />} />
              <Route path="/logout" render={(props) => <Logout {...props} user={this.state.user} />} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </Router>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx